









import { computed, defineComponent, PropType, toRef } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useRole from "@/hooks/useRole";
import BaseIcon from "@/components/Base/BaseIcon";

export default defineComponent({
  name: "UserVerifiedRoleChip",
  components: { BaseIcon },
  props: {
    user: { type: Object as PropType<UserPublicData>, required: true },
  },
  setup(props) {
    const { isFullCreator, isAnyCreator } = useRole(toRef(props, "user"));

    const verified = computed(() => !props.user.disabled && props.user.verified);

    return {
      isFullCreator,
      isAnyCreator,
      verified,
    };
  },
});
